<template>
  <div class="creation-demand-step-planning-type">
    <h2 class="step-title">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@PRECISE_PLANNING_TITLE")) }}
    </h2>
    <section>
      <ExtraBtnSquare icon="fad fa-calendar-check" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@PRECISE_PLANNING_TRUE_CHOICE')" @click="save(true)" />
      <ExtraBtnSquare icon="fad fa-calendar-xmark" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@PRECISE_PLANNING_FALSE_CHOICE')" @click="save()" />
    </section>
  </div>
</template>

<script>
  import { CreationStepPlanningModel, ICreationStepPlanning } from "@core/models";

  export default {
    props: {
      transition: {
        type: Boolean,
        required: false,
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["saveStep"],
    methods: {
      save(isPrecisePlanning) {
        if (isPrecisePlanning) {
          const planning = new CreationStepPlanningModel();
          planning.initFromWeek();
          this.$emit("saveStep", {
            [ICreationStepPlanning.days]: planning[ICreationStepPlanning.days],
            [ICreationStepPlanning.fluctuating]: false,
            [ICreationStepPlanning.hours]: undefined,
          });
        } else {
          this.$emit("saveStep", {
            [ICreationStepPlanning.days]: undefined,
            [ICreationStepPlanning.fluctuating]: true,
            [ICreationStepPlanning.hours]: null,
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-planning-type {
    section {
      display: flex;
      align-items: center;
      justify-content: center;

      > button {
        margin: 5px;
      }

      .creation-dates-selected {
        padding: 0px 15px;
      }
    }
  }
</style>
